import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "section-title",
    style: {"margin-bottom":"50px"}
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Blog"),
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://cdn.proxyscrape.com/img/section-shape.png",
      alt: "section-shape"
    })
  ])
], -1)

import BlogCard from '@/components/shared/BlogCard.vue';
import BlogSection from '@/services/blog-section';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BlogSection), (card) => {
      return (_openBlock(), _createBlock(BlogCard, {
        key: card.id,
        card: card
      }, null, 8, ["card"]))
    }), 128))
  ], 64))
}
}

})